import axios from "axios";

// Same-origin API: the deployed HQ frontend now talks to the backend on the
// SAME host that served the page (e.g. production-hub-421.emergent.host).
// This removes the hard dependency on the lxnwrld.com custom domain being
// live at DNS-resolution time for owner authentication.
export const API_BASE = "/api";

export const MUTATION_EVENT = "lxn:mutated";

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("lxn_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

const PUBLIC_PATHS = ["/login", "/registro", "/register", "/recuperar", "/recover", "/p/", "/p"];
api.interceptors.response.use(
  (r) => {
    const m = (r.config?.method || "get").toLowerCase();
    if (m !== "get" && !(r.config?.url || "").startsWith("/auth/login")) {
      window.dispatchEvent(new Event(MUTATION_EVENT));
    }
    return r;
  },
  (err) => {
    if (err.response && err.response.status === 401) {
      const url = err.config?.url || "";
      const isAuthCall = url.includes("/auth/login") || url.includes("/auth/register") || url.includes("/auth/forgot") || url.includes("/guests/accept") || url.includes("/guests/invite/");
      if (!isAuthCall) {
        localStorage.removeItem("lxn_token");
        const path = window.location.pathname;
        if (!PUBLIC_PATHS.some((p) => path.startsWith(p))) {
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(err);
  }
);

export function fileUrl(fileId) {
  if (!fileId) return null;
  const token = localStorage.getItem("lxn_token");
  return `${API_BASE}/files/${fileId}?auth=${encodeURIComponent(token || "")}`;
}

export function thumbUrl(fileId, width) {
  if (!fileId) return null;
  const token = localStorage.getItem("lxn_token");
  return `${API_BASE}/wrld/thumb/${fileId}?w=${width}&auth=${encodeURIComponent(token || "")}`;
}

export default api;
